export const cutString = (str: string, end: number, start = 0): string => {
  if (!!str && str.length - 1 > end) {
    return `${str.slice(start, end)}...`;
  }

  return str;
};

export const isNumeric = (str: string): boolean => {
  return /^\d+$/.test(str);
};

export const removeHTMLTags = (str: string): string => {
  return str.replace('<br>', ' ');
};
